// extracted by mini-css-extract-plugin
export default {"authPage":"authpage_authPage__spagd","error":"authpage_error__CqCZy","formEl":"authpage_formEl__LiBgX"};